/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Tab_MembersInputs */



/**
* | output |
* | --- |
* | "Members" |
*
* @param {Community_Tab_MembersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_tab_members = /** @type {((inputs?: Community_Tab_MembersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Tab_MembersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Miembros")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Membros")
	if (locale === "it") return /** @type {LocalizedString} */ ("Membri")
	return /** @type {LocalizedString} */ ("Members")
});